import { render } from "./Summary.vue?vue&type=template&id=4dad9992"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=4dad9992&lang=scss"

import exportComponent from "/data/jenkins/workspace/b2c-im-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__